import type { FeatureManagementConfig } from "./types";

export function buildSplitConfig(config: FeatureManagementConfig): SplitIO.IBrowserSettings {
  const useLocalhost = config.useLocalhost;
  const hasSdkKey = config.sdkKey.trim().length > 0;
  const useControlOnlyFallback = !useLocalhost && !hasSdkKey;
  const base: SplitIO.IBrowserSettings = {
    core: {
      authorizationKey: useLocalhost || useControlOnlyFallback ? "localhost" : config.sdkKey,
      key: config.userKey,
    },
    streamingEnabled: useLocalhost || useControlOnlyFallback ? false : config.streamingEnabled ?? true,
    startup: {
      readyTimeout: useLocalhost || useControlOnlyFallback ? 1 : 5,
      retriesOnFailureBeforeReady: 1,
      eventsFirstPushWindow: 0,
    },
    urls: config.urls,
  };

  if (useLocalhost) {
    return { ...base, features: config.localFeatures ?? {} };
  }

  if (useControlOnlyFallback) {
    return { ...base, features: {} };
  }

  // PARKS-18603: default MEMORY storage forces a network round-trip to Harness on every
  // fresh document load before any treatment is readable. The /login/callback return is
  // exactly such a load, so the seamless-redirect flag reads as not-ready there and the
  // route falls through to legacy — the flash. LOCALSTORAGE lets the SDK serve the
  // last-known flag definitions from the prior (anonymous) browsing session immediately
  // (SDK_READY_FROM_CACHE), closing the race; streaming still refreshes the cache live.
  return {
    ...base,
    storage: { type: "LOCALSTORAGE", prefix: "mercury_fme" },
  };
}
